module.exports = __webpack_public_path__ + "static/power-img1-2@2x-410fc0b387a7b514c42803d4726a5fe9.png";